import SearchBar from "./SearchBar";
import {Link} from "react-router-dom";
import {useCompareStore} from "../stores/useCompateStore";


export default function Navbar() {
    const {ids} = useCompareStore();
    return (
        <nav className="h-14 border-b bg-white">
            <div className="max-w-7xl mx-auto h-full px-6 flex items-center justify-between">
                <Link to="/phones">
                    <div className="font-semibold text-lg">Sorted.ie</div>
                </Link>

                <SearchBar />

                <div className="flex gap-6 text-sm items-center">
                    <Link to="/phones" className="hover:text-blue-600 transition-colors">
                        Devices
                    </Link>

                    <Link to="/compare" className="relative group hover:text-blue-600 transition-colors">
                        <span>Compare</span>
                        {ids.length > 0 && (
                            <span className="absolute -top-3 -right-3 flex h-4 w-4 items-center justify-center rounded-full bg-blue-600 text-[10px] font-bold text-white shadow-sm">
                        {ids.length}
                    </span>
                        )}
                    </Link>

                    <a href="#" className="hover:text-blue-600 transition-colors">Login</a>
                </div>
            </div>
        </nav>
    );
}